// extracted by mini-css-extract-plugin
export var cardHeader = "_jz-0";
export var reorderHandle = "_jz-3";
export var titleArea = "_jz-1";
export var titleAreaWithHandle = "_jz-2";